import { AiServiceType } from "src/models/ocr";
import { createEntityModel } from "src/store/models/entity/_shared";

export const OCREntityModel = createEntityModel<AiServiceType>();
